import React from 'react'

export const SearchIcon = (props) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' fill='none' {...props}>
      <path d='m15.708 14.297-3.097-3.098A7.004 7.004 0 1 0 11.2 12.61l3.098 3.098a.997.997 0 0 0 1.41-1.41v-.001ZM7.03 12.012a4.983 4.983 0 1 1 0-9.966 4.983 4.983 0 0 1 0 9.966Z' fill='#000'/>
    </svg>
  )
}